import { render, staticRenderFns } from "./DashboardCEO.vue?vue&type=template&id=2f21bc17&scoped=true"
import script from "./DashboardCEO.vue?vue&type=script&lang=js"
export * from "./DashboardCEO.vue?vue&type=script&lang=js"
import style0 from "./DashboardCEO.vue?vue&type=style&index=0&id=2f21bc17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21bc17",
  null
  
)

export default component.exports